module.exports = __webpack_public_path__ + "img/banner2.7f70d69.png";